import { Set } from 'immutable'

import { ContactFragment, SendDelayType } from 'src/graphql/generated/graphql'
import { compact } from 'src/helpers'
import { PartialLine } from 'src/helpers/multitouch'

export const getDelayTypes = (lines: PartialLine[]) =>
  Set<SendDelayType>(lines.map(line => line.sendDelay.type))

export const getIssues = (
  contact: ContactFragment,
  sendDelayTypes: Set<SendDelayType>,
  USStates: string[],
) =>
  getAddressIssues(contact, USStates).concat(
    getSendDelay(contact, sendDelayTypes),
  )

const getSendDelay = (
  contact: ContactFragment,
  sendDelayTypes: Set<SendDelayType>,
) =>
  compact(
    sendDelayTypes.has(SendDelayType.Bir) && !contact.birthday && 'No birthday',
    sendDelayTypes.has(SendDelayType.Ann) &&
      !contact.anniversary &&
      'No anniversary',
  )

const officialStateLikeValues = ['AE', 'AP', 'AA']
const officialPostOfficeValues = ['APO', 'FPO', 'DPO']

const hasOfficialStateLikeValue = (value: string) => {
  return (
    officialStateLikeValues.find(stateLikeValue =>
      value.split(' ').find(splittedValue => splittedValue === stateLikeValue),
    ) !== undefined
  )
}

const hasOfficialPostOfficeValue = (value: string) => {
  return (
    officialPostOfficeValues.find(POLikeValue =>
      value.split(' ').find(splittedValue => splittedValue === POLikeValue),
    ) !== undefined
  )
}

const getAddressIssues = (
  contact: ContactFragment,
  USSTates: string[],
): string[] =>
  compact(
    !contact.firstName &&
      !contact.lastName &&
      !contact.company &&
      'First name, last name, and company are all blank',
    !contact.address1 && 'Missing Address 1',
    !contact.city && 'Missing City',
    !contact.postalCode && 'Missing Postal Code',
    !contact.country && 'Missing Country',
    (contact.country === 'United States' || contact.country === 'USA') &&
      !contact.state &&
      'Missing State',
    (contact.country === 'United States' || contact.country === 'USA') &&
      (!contact.state ||
        USSTates.filter(value => value === contact.state).length === 0) &&
      'Invalid State or Country',
    contact.country !== 'United States' &&
      (hasOfficialPostOfficeValue(contact.city) ||
        hasOfficialStateLikeValue(contact.city) ||
        hasOfficialPostOfficeValue(contact.state) ||
        hasOfficialStateLikeValue(contact.state)) &&
      'Invalid US Official/Government address.\nMust have country as United States, and State as AE/AP/AA.',
  )
